<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 700px">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Selecione os Filtros</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Depois de selecionado, click em 'ok' para carregar os dados.
          </q-card-section>
        </div>

        <div v-if="!dataDisable" class="row text-brand-5 text-weight-bold">
          <span style="width: 48%" class="col-2 q-ml-sm q-mt-sm titulo-input"
            >Data Inicial</span
          >
          <span style="width: 44%" class="col-2 q-ml-sm q-mt-sm titulo-input"
            >Data Final</span
          >
        </div>

        <div v-if="!dataDisable" class="row col col-3 q-px-sm">
          <q-input
            style="width: 49%"
            class="col input input-font-size"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data1.from"
            mask="##/##/####"
            :disable="dataDisable"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    :options="optionsFn"
                    mask="DD/MM/YYYY"
                    v-model="filtros.data1"
                    range
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <q-input
            class="col q-ml-sm input"
            style="width: 49%"
            dense
            outlined
            placeholder="DD/MM/AAAA"
            v-model="filtros.data1.to"
            mask="##/##/####"
            :disable="dataDisable"
          >
          </q-input>
        </div>

        <div
          v-if="!unidadeDisable && tipoSelecao == 'multiple'"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="tipoSelecao == 'multiple'" class="col">
            <div class="titulo-input">Selecione as Unidades</div>
            <q-select
              dense
              outlined
              class="input-font-size"
              behavior="menu"
              v-model="filtros.unidadeSelecionada"
              multiple
              map-options
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
          <div v-if="regiao" class="col">
            <div class="titulo-input">Região</div>
            <q-input
              class="input-font-size"
              v-model="filtros.regiao"
              dense
              outlined
            />
          </div>
        </div>
        <div
          class="row col q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
          v-if="tipoSelecao == 'single' && !unidadeDisable"
        >
          <div class="col">
            <div class="titulo-input">Selecione a Unidade</div>
            <q-select
              class="input-font-size"
              dense
              outlined
              behavior="menu"
              option-label="label"
              option-value="value"
              v-model="filtrosSingle"
              :options="optionsUnidade"
            />
          </div>
          <div v-if="regiao" class="col">
            <div class="titulo-input">Região</div>
            <q-input
              class="input-font-size"
              v-model="filtrosSingle.regiao"
              dense
              outlined
            />
          </div>
        </div>
        <div
          v-if="tipoSelecao == 'singleOrigemDestino' && !unidadeDisable"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div class="col">
            <div class="text-brand-5 text-weight-bold titulo-input">Origem</div>
            <q-select
              dense
              outlined
              behavior="menu"
              class="input-font-size"
              v-model="filtrosSingleOrigemDestino.origem"
              option-label="label"
              option-value="value"
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
          <div class="col">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Destino
            </div>
            <q-select
              dense
              outlined
              behavior="menu"
              class="input-font-size"
              v-model="filtrosSingleOrigemDestino.destino"
              option-label="label"
              option-value="value"
              :bg-color="unidadeDisable ? 'brand-7' : ''"
              :disable="unidadeDisable"
              :options="optionsUnidade"
            />
          </div>
        </div>
        <div
          v-if="tipoSelecao == 'ferramentaria'"
          class="row q-gutter-sm q-px-sm q-mt-xs text-brand-5 text-weight-bold"
        >
          <div v-if="!desativarUnidade" :class="classUnidade">
            <div class="texto-titulo-input titulo-input">
              Selecione a Unidade
            </div>
            <q-select
              dense
              class="input-font-size"
              behavior="menu"
              outlined
              option-label="label"
              option-value="value"
              v-model="filtrosFerramentaria.unidade"
              :options="optionsUnidade"
            />
          </div>
          <div v-if="!desativarCodigo" :class="classCodigo">
            <div class="text-brand-5 text-weight-bold titulo-input">Codigo</div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.codigo"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarDescricao" :class="classDescricao">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Descrição
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.descricao"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarFornecedorSelect" :class="classFornecedorSelect">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Fornecedor
            </div>
            <SelecaoFornecedor
              :model="filtrosFerramentaria.fornecedorSelect"
              :desabilitado="true"
              :unidadeId="filtrosFerramentaria.unidade?.id"
              @enviarFornecedor="receberFornecedor"
            />
          </div>
          <div v-if="!desativarFornecedor" :class="classFornecedor">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Fornecedor
            </div>
            <q-input dense outlined v-model="filtrosFerramentaria.fornecedor" />
          </div>
          <div v-if="!desativarPatrimonio" :class="classPatrimonio">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Patrimônio
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.patrimonio"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarNumero" :class="classNumero">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Nº Transferência
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.numero"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarTipoMovimento" :class="classTipoMovimento">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Tipo Movimento
            </div>
            <q-select
              class="input-font-size"
              v-model="filtrosFerramentaria.tipoMovimento"
              dense
              outlined
              :options="optionsTipoMovimento"
            />
          </div>
          <div v-if="!desativarGrupo" :class="classGrupo">
            <div class="text-brand-5 text-weight-bold titulo-input">Grupo</div>
            <SelecaoGrupo
              :catalogoUuid="catalogoUuid.catalogoUuid"
              :grupoUuid="filtrosFerramentaria?.subGrupo?.catalogoGrupoUuid"
              :model="filtrosFerramentaria?.grupo"
              @enviarGrupo="receberGrupoFiltro"
            />
          </div>
          <div v-if="!desativarSubGrupo" :class="classSubgrupo">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Sub Grupo
            </div>
            <SelecaoSubgrupo
              :grupoUuid="filtrosFerramentaria?.grupo?.catalogoGrupoUuid"
              @enviarSubgrupo="receberSubgrupoFiltro"
              :model="filtrosFerramentaria?.subGrupo"
            />
          </div>

          <div v-if="!desativarOrigem" :class="classOrigem">
            <div class="text-brand-5 text-weight-bold titulo-input">Origem</div>
            <q-select
              option-label="descricao"
              :options="listaOrigem"
              behavior="menu"
              :multiple="origimIsMultiple"
              v-model="filtrosFerramentaria.origem"
              dense
              class="input-font-size"
              outlined
            />
          </div>

          <div v-if="!desativarStatus" :class="classStatus">
            <div class="text-brand-5 text-weight-bold titulo-input">Status</div>
            <q-select
              option-label="status"
              option-value="status"
              :options="listaStatus"
              behavior="menu"
              :multiple="statusIsMultiple"
              v-model="filtrosFerramentaria.status"
              dense
              emit-value
              class="input-font-size"
              outlined
            />
          </div>

          <div v-if="!desativarSolicitante" :class="classSolicitante">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Solicitante
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.solicitante"
              dense
              outlined
            />
          </div>

          <div v-if="!desativarDevolucao" :class="classDataInicial">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Data inicial
            </div>

            <q-input
              class="col input input-font-size"
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtrosFerramentaria.dataRetirada"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      :options="optionsFn"
                      mask="DD/MM/YYYY"
                      v-model="filtrosFerramentaria.dataRetirada"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div v-if="!desativarRetirada" :class="classDataFinal">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Data Final
            </div>
            <q-input
              class="input input-font-size"
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtrosFerramentaria.dataDevolucao"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      :options="optionsFn"
                      mask="DD/MM/YYYY"
                      v-model="filtrosFerramentaria.dataDevolucao"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div v-if="!desativarTempo" :class="classTempo">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Tempo Excedido
            </div>
            <q-select
              class="input-font-size"
              v-model="filtrosFerramentaria.tempo"
              dense
              outlined
              :options="tempoOptions"
            />
          </div>
          <div v-if="!desativarCentro" :class="classCentro">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Centro de Custo
            </div>
            <q-select
              style="width: 100%; height: 100%"
              v-model="filtrosFerramentaria.centro"
              option-label="name"
              option-value="code"
              label-color="grey-6"
              :options="centroOptions"
              dense
              multiple
              outlined
              input-debounce="0"
              @filter="filterCenter"
              use-input
            />
          </div>
          <div v-if="!desativarDocumentoEntrada" :class="classDocumentoEntrada">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Documento Entrada
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.documentoEntrada"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarDocumentoSaida" :class="classDocumentoSaida">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Documento Saida
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.documentoSaida"
              dense
              outlined
            />
          </div>
          <div v-if="!desativarDataEntrada" :class="classDataEntrada">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Data Inicial
            </div>
            <q-input
              class="input-font-size"
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtrosFerramentaria.dataEntrada"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      :options="optionsFn"
                      mask="DD/MM/YYYY"
                      v-model="filtrosFerramentaria.dataEntrada"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div v-if="!desativarDataSaida" :class="classDataSaida">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Data Final
            </div>
            <q-input
              class="input-font-size"
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtrosFerramentaria.dataSaida"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      :options="optionsFn"
                      mask="DD/MM/YYYY"
                      v-model="filtrosFerramentaria.dataSaida"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div v-if="!desativarNtransferencia" :class="classTransferencia">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Nº Transferencia
            </div>
            <q-input
              class="input-font-size"
              v-model="filtrosFerramentaria.numeroTransferencia"
              dense
              outlined
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </div>
          <!-- Alterado para exibir filtros quando o valor for true -->
          <div v-if="filtroEmprestimoAberto" :class="classEmprestimoAberto">
            <div class="text-brand-5 text-weight-bold titulo-input">
              Empréstimos em Aberto
            </div>
            <q-select
              class="input-font-size"
              v-model="filtrosFerramentaria.emprestimoEmAberto"
              :options="emprestimoAbertoOptions"
              dense
              outlined
            />
          </div>
        </div>
        <slot name="conteudo"></slot>

        <q-card-actions align="right" class="bg-white text-teal q-mt-md">
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            dense
            color="primary"
            @click="emitirFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import SelecaoGrupo from "./SelecaoGrupo.vue";
import SelecaoSubgrupo from "./SelecaoSubgrupo.vue";
import SelecaoFornecedor from "./SelecaoFornecedor.vue";

export default {
  components: { SelecaoGrupo, SelecaoSubgrupo, SelecaoFornecedor },
  props: [
    "openModal",
    "loadingValue",
    "unidadeDisable",
    "tipoSelecao",
    "dataDisable",
    "origimIsMultiple",
    "statusIsMultiple",
    "regiao",
    "semUnidade",
    "desativarOrigem",
    "desativarUnidade",
    "desativarDescricao",
    "desativarTempo",
    "desativarCentro",
    "desativarFornecedor",
    "desativarFornecedorSelect",
    "desativarTipoMovimento",
    "desativarDevolucao",
    "desativarRetirada",
    "desativarSolicitante",
    "desativarGrupo",
    "desativarSubGrupo",
    "desativarDocumentoEntrada",
    "desativarDocumentoSaida",
    "desativarDataEntrada",
    "desativarDataSaida",
    "desativarPatrimonio",
    "desativarNumero",
    "desativarNtransferencia",
    "desativarStatus",
    "desativarCodigo",
    "filtroEmprestimoAberto",
    "classUnidade",
    "classCodigo",
    "classDescricao",
    "classTempo",
    "classGrupo",
    "classSubgrupo",
    "classSolicitante",
    "classDataFinal",
    "classDataInicial",
    "classDocumentoEntrada",
    "classDocumentoSaida",
    "classDataEntrada",
    "classDataSaida",
    "classOrigem",
    "classFornecedor",
    "classFornecedorSelect",
    "classTipoMovimento",
    "classNumero",
    "classPatrimonio",
    "classTransferencia",
    "classCentro",
    "classEmprestimoAberto",
    "classStatus",
  ],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const unidade = ref("");
    const catalogoUuid = salvarCatalogoUuid();
    const centroOptions = ref([]);
    const emprestimoAbertoOptions = ref([
      { label: "Sim", value: "sim" },
      { label: "Não", value: "nao" },
    ]);
    const time = ref(null);
    const filtros = ref({
      data1: { from: "", to: "" },
      regiao: "",
      unidadeSelecionada: [
        {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        },
      ],
    });
    const filtrosSingle = ref({
      id: store.state.org.unidadeData.id,
      label: store.state.org.unidadeData.nome,
      regiao: "",
    });
    const filtrosSingleOrigemDestino = ref({
      origem: {
        id: store.state.org.unidadeData.id,
        label: store.state.org.unidadeData.nome,
      },
      destino: {
        id: "",
        label: "",
      },
    });

    const filtrosFerramentaria = ref({
      codigo: "",
      grupo: "",
      descricao: "",
      subGrupo: "",
      origem: [],
      status: [],
      unidade: {
        id: store.state.org.unidadeData.id,
        label: store.state.org.unidadeData.nome,
      },
      dataRetirada: "",
      dataDevolucao: "",
      solicitante: "",
      documentoSaida: "",
      documentoEntrada: "",
      dataEntrada: "",
      dataSaida: "",
      catalogoUuid: "",
      fornecedor: "",
      fornecedorSelect: "",
      patrimonio: "",
      numero: "",
      tipoMovimento: "",
      numeroTransferencia: "",
      tempo: "",
      centro: [],
      emprestimoAberto: {},
    });
    const optionsUnidade = ref([]);
    const listaStatus = ref([]);
    const quasar = useQuasar();
    const loading = ref(false);
    const abrirModal = ref(
      route.params.id != "" &&
        route.params.id != undefined &&
        route.params.id != "carregado"
        ? false
        : true
    );
    const persistent = ref(true);
    const id = route.params.id;

    const emitirFiltros = async () => {
      loading.value = true;
      if (
        props.semUnidade != "vazio" &&
        filtros.value.unidadeSelecionada.length == 0 &&
        !props.unidadeDisable
      ) {
        quasar.notify({
          message: "Selecione ao menos uma unidade Unidades",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (filtros.value.data1.from == "") {
        let dataInicial = new Date();
        let dataFinal = new Date();
        dataFinal.setDate(dataFinal.getDate());
        dataInicial.setDate(dataInicial.getDate() - 15);
        filtros.value.data1.from = dataInicial.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        filtros.value.data1.to = dataFinal.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }

      if (
        filtrosFerramentaria.value.dataEntrada == "" &&
        filtrosFerramentaria.value.dataRetirada == ""
      ) {
        let dataInicial = new Date();
        let dataFinal = new Date();
        dataFinal.setDate(dataFinal.getDate());
        dataInicial.setDate(dataInicial.getDate() - 15);
        filtrosFerramentaria.value.dataEntrada = dataInicial.toLocaleDateString(
          "pt-BR",
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }
        );
        filtrosFerramentaria.value.dataSaida = dataFinal.toLocaleDateString(
          "pt-BR",
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }
        );
      }

      if (
        filtrosFerramentaria.value.dataRetirada == "" &&
        filtrosFerramentaria.value.dataDevolucao == ""
      ) {
        let dataInicial = new Date();
        let dataFinal = new Date();
        dataFinal.setDate(dataFinal.getDate());
        dataInicial.setDate(dataInicial.getDate() - 15);
        filtrosFerramentaria.value.dataRetirada =
          dataInicial.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        filtrosFerramentaria.value.dataDevolucao = dataFinal.toLocaleDateString(
          "pt-BR",
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }
        );
      }

      if (filtros.value.data1 != "") {
        filtros.value.data1.from = filtros.value.data1.from
          .split("/")
          .reverse()
          .join("-");

        filtros.value.data1.to = filtros.value.data1.to
          .split("/")
          .reverse()
          .join("-");
      }

      if (props.tipoSelecao == "multiple") {
        emit("unidade", filtros.value);
      }

      if (props.tipoSelecao == "single") {
        emit("unidade", filtros.value.data1, filtrosSingle.value);
      }

      if (props.tipoSelecao == "singleOrigemDestino") {
        emit("unidade", filtros.value.data1, filtrosSingleOrigemDestino.value);
      }

      if (props.tipoSelecao == "ferramentaria") {
        emit("unidade", filtros.value.data1, filtrosFerramentaria.value);
      }

      filtros.value.data1 = { from: "", to: "" };
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtrosFerramentaria.value.grupo = "";
        return;
      }
      filtrosFerramentaria.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtrosFerramentaria.value.subGrupo = "";
        return;
      }
      filtrosFerramentaria.value.subGrupo = value;
    };

    const listarUnidades = async () => {
      optionsUnidade.value.push({
        label: "Todas",
        id: "",
      });
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
        const response2 = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: filtrosFerramentaria.value.unidade.id,
        });

        filtrosFerramentaria.value.catalogoUuid =
          response2.response.data.resultado.dados[0]?.catalogoUuid;
      } catch (error) {
        console.log(error);
      }
    };

    const receberFornecedor = (value) => {
      filtrosFerramentaria.value.fornecedorSelect = value;
    };

    const getCentros = async (val) => {
      const response = await store.dispatch("pkg/getCentrosCustos", {
        search: val,
      });

      centroOptions.value = response.data.results.data;
    };

    const getStatus = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarStatusAtivos",
          {
            catalogoUuid: await catalogoUuid.catalogoUuid.value,
          }
        );

        listaStatus.value = response.data.resultado.dados;
      } catch (error) {
        console.warn("Erro ao carregar status dos ativos:", error);
        listaStatus.value = [];
      }
    };

    setTimeout(() => {
      if (!props.desativarStatus) {
        getStatus();
      }
    }, 1500);

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
          }, 1000);
        }
      }
    );
    watch(
      () => props.openModal,
      () => {
        abrirModal.value = true;
      }
    );

    watch(
      () => filtrosFerramentaria.value.unidade,
      async () => {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: filtrosFerramentaria.value.unidade.id,
        });

        filtrosFerramentaria.value.catalogoUuid =
          response.response.data.resultado.dados[0]?.catalogoUuid;
      }
    );

    watch(
      () => filtros.value.unidadeSelecionada,
      () => {
        filtros.value.unidadeSelecionada.forEach((unidade) => {
          if (
            unidade.label == "Todas" &&
            filtros.value.unidadeSelecionada.length > 1
          ) {
            filtros.value.unidadeSelecionada = [];
            filtros.value.unidadeSelecionada = [{ label: "Todas", id: "" }];
          }
        });
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidadeSelecionada[0].id = store.state.org.unidadeData.id;
        filtros.value.unidadeSelecionada[0].label =
          store.state.org.unidadeData.nome;
        filtrosSingle.value.label = store.state.org.unidadeData.nome;
        filtrosSingle.value.id = store.state.org.unidadeData.id;
        filtrosSingleOrigemDestino.value = {
          origem: {
            id: store.state.org.unidadeData.id,
            label: store.state.org.unidadeData.nome,
          },
        };
      }
    );

    const verificarPersistencia = async () => {
      if (id) {
        persistent.value = false;
      }
    };

    onMounted(verificarPersistencia);
    onMounted(listarUnidades);

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
        filtros.value.unidadeSelecionada[0].id = unidade.value.id;
        filtros.value.unidadeSelecionada[0].label = unidade.value.nome;
        filtrosSingle.value.label = unidade.value.nome;
        filtrosSingle.value.id = unidade.value.id;
      }
    };
    onMounted(getUnidade);
    return {
      abrirModal,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,

      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
      emitirFiltros,
      loading,
      persistent,
      verificarPersistencia,
      listarUnidades,
      optionsUnidade,
      receberFornecedor,
      filtrosSingle,
      centroOptions,
      filtrosSingleOrigemDestino,
      unidade,
      filtrosFerramentaria,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      catalogoUuid,
      emprestimoAbertoOptions,
      listaStatus,
      filterCenter(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getCentros(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      optionsTipoMovimento: [
        {
          label: "Transferência Externa Envio",
          value: "transferencia_externa_envio",
        },
        {
          label: "Transferência Interna Envio",
          value: "transferencia_interna_envio",
        },
        {
          label: "Transferência Externa Recebimento",
          value: "transferencia_externa_recebimento",
        },
        {
          label: "Transferência Interna Recebimento",
          value: "transferencia_interna_recebimento",
        },
        {
          label: "Movimentação Manual",
          value: "movimentacao_manual",
        },
        {
          label: "Devolução",
          value: "devolucao",
        },
        {
          label: "Retirada",
          value: "emprestimo",
        },
      ],
      listaOrigem: ["locada", "propria", "consumo"],
      tempoOptions: [
        { label: "Sim", value: "sim" },
        { label: "Não", value: "nao" },
      ],
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 900px) {
  .input {
    width: 47% !important;
  }
}
@media screen and (max-width: 600px) {
  .titulo-input {
    font-size: 12px;
  }
  .input-font-size {
    font-size: 12px;
  }
}
</style>
